// extracted by mini-css-extract-plugin
module.exports = {"maxHeightModal":"styles-module__maxHeightModal___2Cbg9"};